function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import { Button, ArrowDown, ArrowUp } from './styles';
export var ButtonToggle = /*#__PURE__*/forwardRef(function ButtonToggle(_ref, ref) {
  var children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$hideToggle = _ref.hideToggle,
      hideToggle = _ref$hideToggle === void 0 ? false : _ref$hideToggle,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      props = _objectWithoutProperties(_ref, ["children", "disabled", "hideToggle", "open"]);

  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    disabled: disabled
  }, props), children, renderIf(!hideToggle, function () {
    return renderIf(open, function () {
      return /*#__PURE__*/React.createElement(ArrowUp, null);
    }, function () {
      return /*#__PURE__*/React.createElement(ArrowDown, null);
    });
  }));
});
ButtonToggle.propTypes = {
  disabled: PropTypes.bool,
  hideToggle: PropTypes.bool,
  open: PropTypes.bool
};
ButtonToggle.defaultProps = {
  disabled: false,
  hideToggle: false,
  open: false
};
export default ButtonToggle;